import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src3102719317/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
